import type { EffectBuild, EffectBuildableId, GetNextId } from "@skilitics/nautilus-core-designer-data";

import type { GetEffectBuildable } from "./getEffectBuildable.ts";

type Options = {
  getBuildable: GetEffectBuildable;
  getNextId: GetNextId;
};

export const createEffectCreate =
  ({ getBuildable, getNextId }: Options) =>
  (id: EffectBuildableId): EffectBuild => {
    const buildable = getBuildable(id);
    if (!buildable) {
      throw new Error(`No buildable found for node id: ${id.nodeId} and name ${id.name}`);
    }
    const { name, builder, spec, nodeId, targetNodeId } = buildable;
    const effect: EffectBuild = {
      id: getNextId(),
      nodeId,
      targetNodeId,
      buildableName: name,
      config: builder.getInitialConfig?.(spec) ?? {},
    };
    return effect;
  };

export type CreateEffect = ReturnType<typeof createEffectCreate>;
